import React, { FC } from 'react'
import { cls } from '../../../utils/utils'
import styles from './Video.module.scss'

export interface IVideoProps {
  source?: string
  className?: string
}

const getId = (link: string): string => {
  if (link.startsWith('https://www.youtube.com/watch?v=')) {
    return link.replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/')
  }
  if (link.startsWith('https://youtu.be/')) {
    return link.replace('https://youtu.be/', 'https://www.youtube.com/embed/')
  }
  return link
}

const Video: FC<IVideoProps> = ({ source, className }) => {
  return source ? (
    <div className={cls(styles.iframeContainer, className)}>
      <iframe
        src={getId(source)}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  ) : null
}

export default Video
